import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 1. modulos Fid Ui
import { ButtonComponent } from '@fid/fid-ui';
import { CheckboxComponent } from '@fid/fid-ui';
import { InputTextComponent } from '@fid/fid-ui';
import { RadioGroupComponent } from '@fid/fid-ui';

//array con todos los componentes para no repetirlos
const FID_UI_COMPONENTS = [
  ButtonComponent,
  CheckboxComponent,
  InputTextComponent,
  RadioGroupComponent,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...FID_UI_COMPONENTS],
  exports: [...FID_UI_COMPONENTS],
})
export class FidUiModule {}
